import { useCallback, useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Heading } from '@televet/kibble-ui/Heading';
import { Flex } from '@televet/kibble-ui/chakra';
import { PageContainer } from '@/components/PageContainer';
import { Breadcrumbs } from '@/components/Breadcrumbs';
import { BackfillList } from './-components/BackfillList';
import { BackfillRequestPanel } from './-components/BackfillRequestPanel';
import {
  BackfillTemplateList,
  type BackfillTemplateView,
} from './-components/BackfillTemplateList';
import {
  savedRequestOf,
  withSavedRequest,
  type SavedRequest,
  type SavedRequests,
} from './-lib/savedRequests';

export const Route = createFileRoute('/_authenticated/emitters/backfills/')({
  component: Backfills,
});

function Backfills() {
  const [selected, setSelected] = useState<BackfillTemplateView | null>(null);
  const [savedRequests, setSavedRequests] = useState<SavedRequests>({});

  const updateSavedRequest = useCallback(
    (templateKey: string, patch: Partial<SavedRequest>) =>
      setSavedRequests((saved) => withSavedRequest(saved, templateKey, patch)),
    []
  );

  return (
    <PageContainer>
      <Flex direction="column" w="100%" gap={6}>
        <Breadcrumbs items={[{ label: 'Backfills' }]} />
        <Flex direction="column" gap={3}>
          <Heading size="lg">Backfills</Heading>
          <BackfillList />
        </Flex>
        <Flex direction="column" gap={3}>
          <Heading size="md">Templates available for backfill</Heading>
          <BackfillTemplateList onSelect={setSelected} />
        </Flex>
      </Flex>
      <BackfillRequestPanel
        template={selected}
        saved={selected && savedRequestOf(savedRequests, selected.key)}
        onSavedChange={updateSavedRequest}
        onClose={() => setSelected(null)}
      />
    </PageContainer>
  );
}
